import { HttpClient, HttpResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { BaseService } from "src/app/base/services/base.service";
import { Tutorial, TutorialMaterial } from "../models/tutorial.model";

@Injectable()
export class TutorialMaterialService extends BaseService<TutorialMaterial> {

  constructor(public http: HttpClient) {
    super(http);
  }

  public list(): Observable<any[]> {
    return this.http.get<any[]>(this.baseUrl + '/list',  { headers: this.headers });
  }
  

  public uploadFile(id: number,newData:any, file: File): Observable<any> {
    const formData: FormData = new FormData();
    if (file){
      formData.append('import_file', file, file?.name);
    }
    formData.append('newData',  JSON.stringify(newData));
    if(id != null){
      return this.http.post<any>(this.baseUrl + "/" + id, formData);
    }
    else{
      return this.http.post<any>(this.baseUrl, formData);
    }
  }

  
  public updateList(data: any): Observable<any> {
    return this.http.put<any>(this.baseUrl + '/items', data, { headers: this.headers });
  }

  public deleteList(ids: number[]): Observable<any> {
    return this.http.delete<any>(this.baseUrl + '/items', { body: { ids: ids } });
  }

  public downloadFile(id: number): Observable<HttpResponse<Blob>> {
    return this.http.get(this.baseUrl + "/download/" + id, {
      headers: this.headers,
      responseType: 'blob',
      observe: 'response'
    })
  }

  public getPathModule(): string {
    return '/tutorial/class';
  }
}